import{k as r,m as e}from"./chunk-HBP5N4FR.js";e();function i(t){try{return r.Buffer.from(t,"base64").toString()===atob(t)}catch(n){return!1}}function s(t){return btoa(t)}function c(t){return atob(t)}export{i as a,s as b,c};
//# sourceMappingURL=chunk-35N6HQAC.js.map
